<template>
  <el-dialog
    title="流程描述"
    :visible.sync="isShow"
    destroy-on-close
    width="880px"
    @close="closeDialog"
  >
    <div class="box">
      <el-table :data="approvalHistoryData" style="width: 100%; height: 100%;">
        <el-table-column prop="checkName" label="审批人名称" />
        <el-table-column prop="nodeDesc" label="节点描述" />
        <el-table-column
          prop="status"
          label="节点状态"
        />
        <el-table-column
          prop="ceheckTime"
          label="处理时间"
        >
          <template v-slot="{ row }">
            {{ row.ceheckTime || '-' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-footer">
      <el-button class="btn" @click="closeDialog">
        知道了
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getOrderCheckListNew } from '@/API/creditAxios.js';

export default {
  data () {
    return {
      isShow: false,
      approvalHistoryData: [],
      visibleLoading: false
    };
  },

  methods: {
    openDialog (flowId) {
      this.approvalHistoryData = [];
      this.isShow = true;
      this.getData(flowId);
    },

    closeDialog () {
      this.isShow = false;
    },

    async getData (flowId) {
      this.visibleLoading = true;
      try {
        let params = {
          id: flowId.id
        };
        const list = await getOrderCheckListNew(params);
        if (list.data.status === '200') {
          this.approvalHistoryData = list.data.data || [];
        }
      } catch (error) {
        console.log(error);
      }
      this.visibleLoading = false;
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  border: 1px solid #EBEEF5;
}
.dialog-footer{
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  .btn{
    width: 100px;
    height: 35px;
  }
}

:deep(.el-dialog__title){
  font-size: 16px !important;
}
:deep(.el-dialog__body){
  padding-bottom: 15px;
}
:deep(.el-table__body .el-table__row:nth-last-child(1) .el-table__cell){
  border: 0;
}
:deep(.el-table::before){
  height: 0 !important;
}
:deep(.el-dialog__header){
  background-color: #fff;
  border-bottom: 1px solid #EBEEF5;
}
</style>
